/**
 * ATS Surcharge Handler
 * Gestisce la logica per determinare l'ID della variante di sovrapprezzo
 * in base al formato selezionato e al bucket del colore.
 */

(function() {
  'use strict';

  // Mappatura ID varianti sovrapprezzo ATS
  // Formato: { BUCKET: { FORMATO_KEY: VARIANT_ID } }
  const SURCHARGE_MAP = {
    'BIANCHI': {
      '0.75': '56049114349954',
      '2.5': '56049114382722',
      '4': '56090179469698',
      '5': '56049114415490',
      '10': '56090179568002',
      '12': '56112253436290',
      '12.5': '56112253534594',
      '14': '56049114448258'
    },
    'INTERMEDI': {
      '0.75': '56049114481026',
      '2.5': '56049114513794',
      '4': '56090179502466',
      '5': '56049114546562',
      '10': '56090179600770',
      '12': '56112253469058',
      '12.5': '56112253567362',
      '14': '56049114579330'
    },
    'SCURI': {
      '0.75': '56049114612098',
      '2.5': '56049114644866',
      '4': '56090179535234',
      '5': '56049114677634',
      '10': '56090179633538',
      '12': '56112253501826',
      '12.5': '56112253600130',
      '14': '56049114710402'
    }
  };

  class AtsSurchargeHandler {
    constructor() {
      this.surchargeMap = SURCHARGE_MAP;
    }

    /**
     * Normalizza il titolo della variante per estrarre il formato numerico.
     * @param {string} variantTitle - Es. "0.75 LT", "2,5L", "4 Litri"
     * @returns {string|null} - La chiave del formato (es. "0.75") o null.
     */
    _getFormatKey(variantTitle) {
      if (!variantTitle) return null;
      
      // Normalizza: sostituisce virgola con punto, tutto minuscolo
      const title = variantTitle.replace(',', '.').toLowerCase();

      // Ordine importante: controlla prima i numeri più specifici o lunghi per evitare falsi positivi
      // Es: controllare "14" prima di "4" (anche se con \b il problema si riduce)
      
      // Regex con word boundary (\b) per assicurarsi che il numero sia isolato
      // Cerca il numero seguito opzionalmente da spazi e poi 'l', 'lt', 'litri' o fine stringa/altro
      
      if (/\b14\s*(?:l|lt|litri)?\b/.test(title)) return '14';
      if (/\b12\.5\s*(?:l|lt|litri)?\b/.test(title)) return '12.5';
      if (/\b12\s*(?:l|lt|litri)?\b/.test(title)) return '12';
      if (/\b10\s*(?:l|lt|litri)?\b/.test(title)) return '10';
      if (/\b5\s*(?:l|lt|litri)?\b/.test(title)) return '5';
      if (/\b4\s*(?:l|lt|litri)?\b/.test(title)) return '4';
      if (/\b2\.5\s*(?:l|lt|litri)?\b/.test(title)) return '2.5';
      if (/\b0\.75\s*(?:l|lt|litri)?\b/.test(title)) return '0.75';

      // Fallback più permissivi se le regex sopra sono troppo strette
      if (title.includes('14')) return '14';
      if (title.includes('12.5')) return '12.5';
      if (title.includes('12')) return '12';
      if (title.includes('10')) return '10';
      if (title.includes('2.5')) return '2.5';
      if (title.includes('0.75')) return '0.75';
      
      // Attenzione: questi sono rischiosi se usati con includes senza boundary
      // Ma se siamo arrivati qui, proviamo.
      // Meglio usare regex anche qui per sicurezza
      if (/\b5\b/.test(title)) return '5';
      if (/\b4\b/.test(title)) return '4';

      return null;
    }

    /**
     * Trova l'ID della variante di sovrapprezzo.
     * @param {string} bucket - Il bucket del colore (BIANCHI, INTERMEDI, SCURI)
     * @param {string} variantTitle - Il titolo della variante del prodotto principale.
     * @returns {string|null} - L'ID della variante o null se non trovato.
     */
    getSurchargeVariantId(bucket, variantTitle) {
      if (!bucket || !variantTitle) return null;

      const cleanBucket = bucket.toUpperCase().trim();
      const formatKey = this._getFormatKey(variantTitle);

      if (formatKey && this.surchargeMap[cleanBucket] && this.surchargeMap[cleanBucket][formatKey]) {
        return this.surchargeMap[cleanBucket][formatKey];
      }

      return null;
    }
  }

  // Esporta l'handler globalmente
  window.AtsSurchargeHandler = new AtsSurchargeHandler();

})();
